import React from "react";

type SectionHeadingProps = {
  children: React.ReactNode;
};

export default function SectionHeading({ children }: SectionHeadingProps) {
  return (
    <div className="mb-12">
      <h2 className="font-sans font-semibold text-[1.75rem] tracking-tight
        text-[var(--color-text-primary)] leading-tight">
        {children}
      </h2>
      <div className="mt-3 h-px w-12 bg-[var(--color-brand)] rounded-full" />
    </div>
  );
}
